/**
 * Pay Inputs and the salary breakup show pay on one of two bases: the whole month
 * (working days less LOP, as payroll will run it) or what is earned so far, from the
 * attendance marked up to today. Mirrors payroll-report.service.ts's PayToDate.
 */
export type PayBasis = "month" | "toDate";

export interface PayToDate {
  workingDays: number;
  payable: number;
  present: number;
  paidLeave: number;
  lop: number;
  absent: number;
  missedCheckouts: number;
  remaining: number;
  gross: number | null;
  inHand: number | null;
}

export const BASIS_OPTIONS: { value: PayBasis; label: string }[] = [
  { value: "month", label: "Month pay" },
  { value: "toDate", label: "Pay to date" },
];

const AS_OF = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });

/** "26 Oct 2026" from a "YYYY-MM-DD" day. */
export function fmtAsOf(day: string): string {
  return AS_OF.format(new Date(`${day}T00:00:00Z`));
}
